import { useMemo, useState } from "react";

// ícone "camadas" 
const LayersIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z" />
    <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" />
    <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" />
  </svg>
);

// ícone "ordenar" 
const SortIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m21 16-4 4-4-4" />
    <path d="M17 20V4" />
    <path d="m3 8 4-4 4 4" />
    <path d="M7 4v16" />
  </svg>
);

const formatCompact = (value) => `R$ ${Math.round(value / 1000)}k`;

// Botão "Ordenar" 
const SORT_MODES = { GAIN: "gain", NAME: "name" };
const SortToggle = ({ mode, onToggle }) => (
  <button onClick={onToggle} style={{
    width: "100%", display: "flex", alignItems: "center", gap: 8,
    padding: "9px 12px", marginBottom: 10,
    background: "#f7f7f5", border: "1px solid #eee", borderRadius: "8px",
    cursor: "pointer", fontSize: "12.5px", color: "#555", fontWeight: "500",
  }}>
    <SortIcon />
    Ordenar: {mode === SORT_MODES.GAIN ? "Ganho (maior→)" : "Nome (A→Z)"}
  </button>
);

// Card de um grupo na lista 
const GroupCard = ({ group, isSelected, barPercent, onSelect }) => (
  <button onClick={() => onSelect(group.id)} style={{
    width: "100%", textAlign: "left", padding: "12px 14px", marginBottom: 8,
    borderRadius: "12px", cursor: "pointer",
    background: isSelected ? "#fff5ec" : "#fff",
    border: isSelected ? "1.5px solid #f4c9a6" : "1.5px solid #efefef",
    // faixa colorida encostada na borda esquerda quando o card está selecionado
    borderLeft: isSelected ? "4px solid #E8773A" : "1.5px solid #efefef",
  }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 6 }}>
      <span style={{ fontSize: "13.5px", fontWeight: "700", color: "#1a1a1a" }}>{group.name}</span>
      <span style={{ fontSize: "12.5px", fontWeight: "700", color: "#16a34a" }}>{formatCompact(group.expectedGain)}</span>
    </div>
    <div style={{ height: 5, borderRadius: 3, background: "#f0f0ee", overflow: "hidden", marginBottom: 6 }}>
      <div style={{ height: "100%", width: `${barPercent}%`, background: "#16a34a", borderRadius: 3 }} />
    </div>
    <span style={{ fontSize: "11.5px", color: "#999" }}>
      {group.skuCount} SKUs · {group.planCount} planos
    </span>
  </button>
);

// Coluna esquerda completa 
export const GroupList = ({ groups, selectedGroupId, onSelectGroup }) => {

  const [sortMode, setSortMode] = useState(SORT_MODES.GAIN);
  const maxGain = useMemo(() => Math.max(...groups.map(g => g.expectedGain)), [groups]);

  const sortedGroups = useMemo(() => {
    const copy = [...groups];
    return sortMode === SORT_MODES.GAIN
      ? copy.sort((a, b) => b.expectedGain - a.expectedGain)
      : copy.sort((a, b) => a.name.localeCompare(b.name));
  }, [groups, sortMode]);

  return (
    // sem borda/sombra/radius próprios — agora faz parte do card único
    // junto com o painel da direita (o MixQualification.jsx que desenha isso)
    <section style={{
      padding: "16px",
      display: "flex", flexDirection: "column", width: 300, flexShrink: 0,
      height: "100%", minHeight: 0,
    }}>
      {/* título */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
        <span style={{
          width: 34, height: 34, borderRadius: "50%", backgroundColor: "#E8773A", // ← redondo agora
          display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        }}>
          <LayersIcon />
        </span>
        <div>
          <p style={{ fontSize: "14px", fontWeight: "700", color: "#1a1a1a" }}>Grupos de produto</p>
          <p style={{ fontSize: "11.5px", color: "#999" }}>{groups.length} times de produtos</p>
        </div>
      </div>

      <SortToggle mode={sortMode} onToggle={() => setSortMode(p => p === SORT_MODES.GAIN ? SORT_MODES.NAME : SORT_MODES.GAIN)} />

      {/* só esta lista rola — o card em si não cresce */}
      <div style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
        {sortedGroups.map(group => (
          <GroupCard
            key={group.id}
            group={group}
            isSelected={group.id === selectedGroupId}
            barPercent={(group.expectedGain / maxGain) * 100}
            onSelect={onSelectGroup}
          />
        ))}
      </div>
    </section>
  );
};
